<!--
 * @Description: 
 * @Date: 2020-11-03 09:41:19
-->
<template>
  <el-dialog :visible="showDialog" width="80%" class="chartDia" @close="close">
    <div slot="title" class="slotTit">支付明细</div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      :stripe="true"
      :highlight-current-row="false"
    >
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="80"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="fullName"
        label="客户姓名"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dutyName"
        label="职称"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="hospitalName"
        label="医院"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="departmentName"
        label="科室"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createUserName"
        label="创建人"
      ></el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="paginationData.pageNum"
      :total="totalElements"
      :page-size="paginationData.pageSize"
      layout="total, prev, pager, next, jumper"
      style="padding:15px"
    ></el-pagination>
  </el-dialog>
</template>
<script>
import { pageInation } from '@/Mixin/listMixin';
import { academy } from '@/api/ajax';
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  mixins: [pageInation],
  data() {
    return {
      getList: academy.xueshuCustomerList // 获取列表的AJAX
    };
  },
  methods: {
    close() {
      this.$parent.showDetail = false;
    }
  }
};
</script>
